document.querySelectorAll('[data-bnl-live-offer]').forEach((offer) => {
  offer.querySelectorAll('[data-bnl-live-color-select]').forEach((details) => {
    const field=details.closest('.bnl-live-offer__variant-field');
    const select=field?.querySelector('[data-bnl-live-variant]');
    const thumb=details.querySelector('[data-bnl-live-thumb]');
    const label=details.querySelector('[data-bnl-live-label]');
    const unitColor=field?.closest('.bnl-live-offer__variant-row')?.querySelector('[data-bnl-live-unit-color]');
    const sync=()=>{
      const option=select?.options[select.selectedIndex];
      const colorName=option?.dataset.title||option?.textContent||'';
      if(option?.dataset.image && thumb) thumb.src=option.dataset.image;
      if(label && option) label.textContent=colorName;
      if(unitColor) unitColor.textContent=colorName;
      details.querySelectorAll('[data-bnl-live-choice]').forEach(btn=>btn.setAttribute('aria-pressed',btn.dataset.bnlLiveChoice===select?.value?'true':'false'));
    };
    details.querySelectorAll('[data-bnl-live-choice]').forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled||!select)return;
      select.value=btn.dataset.bnlLiveChoice;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      details.open=false;
    }));
    select?.addEventListener('change',sync); sync();
  });
});

document.querySelectorAll('[data-bnl-live-offer]').forEach((wrapper) => {
  const button = wrapper.querySelector('[data-bnl-live-action]');
  const colorStep = wrapper.querySelector('[data-bnl-live-color-step]');
  const message = wrapper.querySelector('.bnl-live-offer__message');

  if (!button || button.dataset.bnlBound === 'true') return;
  button.dataset.bnlBound = 'true';

  button.dataset.stage = 'reveal';
  colorStep?.setAttribute('aria-hidden','true');

  button.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.stage === 'reveal') {
      wrapper.classList.add('is-choosing-colors');
      colorStep?.setAttribute('aria-hidden','false');
      button.setAttribute('aria-expanded','true');
      button.dataset.stage = 'add';
      requestAnimationFrame(() => colorStep?.querySelector('summary')?.focus({preventScroll:true}));
      return;
    }

    button.disabled = true;
    message.textContent = '';
    try {
      const quantities = new Map();
      wrapper.querySelectorAll('[data-bnl-live-variant]').forEach((select) => {
        quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
      });
      const items = Array.from(quantities, ([id, quantity]) => ({id:Number(id), quantity}));
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({items})
      });
      const product = await response.json();
      if(!response.ok) throw product;
      const code=(wrapper.dataset.discount||'').trim();
      if(code) await fetch(window.Shopify.routes.root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(window.Shopify.routes.root+'cart'),{credentials:'same-origin'});
      button.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product,addToCartBtn:button}}));
      message.textContent='';
    } catch(error) {
      message.textContent=error.description||error.message||String(error);
    } finally {
      button.disabled=false;
    }
  });
});
